import LanguageSelect from "@/components/language-select/index";
import Logo from "@/components/logo/index";
import NavigationElement from "@/components/navigation-element/index";
import Iconized from "@/components/iconized/index";
import NAVIGATION from "@/data/navigation.yaml";
import NAVIGATION_MOBILE from "@/data/navigation-mobile.yaml";

const THEMES = ["dark", "light"];
const SPECIAL_THEMES = ["nevoky", "spark", "zoru"];
const DARK_THEMES = ["dark", "nevoky", "spark", "zoru"];

export default {
  components: { LanguageSelect, Logo, NavigationElement, Iconized },
  data() {
    const authUrl = process.env.VUE_APP_AUTH_URL;
    const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");

    return {
      authUrl,
      darkModeQuery,
      theme: darkModeQuery.matches ? "dark" : "light",
    };
  },
  computed: {
    navigationElements() {
      return NAVIGATION;
    },
    mobileNavigationElements() {
      return NAVIGATION_MOBILE;
    },
    darkTheme() {
      return DARK_THEMES.indexOf(this.theme) >= 0;
    },
  },
  methods: {
    setNextTheme() {
      let rand = Math.random();

      if (rand > 0.97) {
        const index = Math.floor(Math.random() * SPECIAL_THEMES.length);
        this.theme = SPECIAL_THEMES[index];
        return;
      }

      const currentThemeIndex = THEMES.indexOf(this.theme);
      const nextThemeIndex = (currentThemeIndex + 1) % THEMES.length;
      this.theme = THEMES[nextThemeIndex];
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.$refs.view.scrollTop = 0;
    next();
  },
  mounted() {
    this.darkModeQuery.addEventListener("change", () => {
      this.darkMode = this.darkModeQuery.matches;
    });
  },
};
